import { render, staticRenderFns } from "./inviteRegisterSuccess.vue?vue&type=template&id=dab8b6a6&scoped=true"
import script from "./inviteRegisterSuccess.vue?vue&type=script&lang=js"
export * from "./inviteRegisterSuccess.vue?vue&type=script&lang=js"
import style0 from "./inviteRegisterSuccess.vue?vue&type=style&index=0&id=dab8b6a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_3rwm2qttujvjuolkwtduiruple/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab8b6a6",
  null
  
)

export default component.exports